(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('HeConnectivity', HeConnectivity);

    HeConnectivity.$inject = ['$resource'];

    function HeConnectivity ($resource) {
        var resourceUrl =  'api/he-connectivity-settings/:id';
        
        return $resource(resourceUrl, {}, {
        	'query': { method: 'GET', isArray: true,
        		params: {orgId:'@orgId'},
        	    url: 'api/orgId/:orgId/he-connectivity-settings'
        	 },
         	
        	 'get': {
                 method: 'GET',
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                     }
                     return data;
                 }
             },           
            	
             'save': {
                 method: 'POST',
                 params: {orgId:'@orgId'},
                 url: 'api/he-connectivity-settings/orgId/:orgId',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                     return angular.toJson(copy);
                 }                
             },
        	
             'update': {
             	method:'PUT',
             	params: {orgId:'@orgId'},
                url: 'api/update-he-connectivity-settings/orgId/:orgId',
             	transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	
                     return angular.toJson(copy);
                 }
             },
             'approve': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/approve'
             },
             'reject': {
                 method: 'GET',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/reject'
             },
             'discard': {
               	 method: 'GET',
                    params: {taskId:'@taskId'},
                    url: 'api/tasks/:taskId/discard'
              },
              'resubmit': {
                  method: 'PUT',
                  params: {taskId:'@taskId'},
                  url: 'api/tasks/:taskId/resubmit/he-connectivity-settings',
                  transformRequest: function (data) {
                  	var copy = angular.copy(data);
                  	return angular.toJson(copy);
                  }
              },
              'changeStatus': {
                  method: 'POST',
                  params: {status:'@status'},
                  url: 'order/he-interactive-status-update'
              }
              
        });
    }
})();
